import { createContext } from "react";
export default createContext({
    locale: "",
    language: ""
});
